import * as Sentry from '@sentry/react';
import { useState } from 'react';
import { getSessionId } from '@britishcouncil/react-common';
import { OidcContext } from '@britishcouncil/react-oidc-auth';
import { useAppSettings } from 'settings';

export const useSentry = () => {
  const {
    sentry: { environment, release },
  } = useAppSettings();
  const { user } = OidcContext.useAuth();
  const [isInitialized, setIsInitialized] = useState(false);

  if (import.meta.env.PROD && !isInitialized) {
    Sentry.init({
      dsn: 'https://31f8fd62642912863e7798201419f7df@o505679.ingest.us.sentry.io/4508954065174528',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
      ],
      sendDefaultPii: true,
      tracesSampleRate: 1.0,
      environment,
      release,
      enableLogs: true,
    });

    Sentry.setTags({
      sessionId: getSessionId(),
      userId: user?.profile.sub,
    });

    setIsInitialized(true);
  }
};
